import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import ListagemHeader from '../../../components/gww-lib/listagens-header';
import NavBar from '../../../components/layout/navbar/index';

function ListaProduto({ history }) {

    function vaiProduto(registroUnico) {
        history.push('/cadastro-produto', { registroUnico });
    }

    const columns = {
        dic: [
            { id: 'CCDPMS', label: 'Código', minWidth: 10 },
            { id: 'CDSPMS', label: 'Descrição', minWidth: 10 },
            { id: 'CCDNCM', label: 'NCM', minWidth: 10 },          
        ]
    };

    let filtrosProduto = {
        dic: [
            {
                campoFiltro: "CDSPMS",
                descricaoFiltro: "Descrição",
            },
            {
                campoFiltro: "CCDPMS",
                descricaoFiltro: "Código",
            },
           
            
        ],
    };

    

    return (
        <Fragment>
            <NavBar />
            <ListagemHeader
                filtros={filtrosProduto}
                columns={columns}
                tela="ListaProduto"
                titulo="Produto"
                nomeChave="PCCDPMS"
                metodoListagem="WEBSITE_LISTAGEM_GPMS"
                metodoConsultaUnica="WEBSITE_GPMS_BYID"
                vaiPara={(registro) => vaiProduto(registro)}
            />

        </Fragment>
    )
}

export default withRouter(ListaProduto);